import { createSlice } from "@reduxjs/toolkit";
import { StepperSliceROWState } from "../types";

const initialState: StepperSliceROWState = {
  activeStep: 0,
  coordinateSite: "start",
};

const StepperROWStateSlice = createSlice({
  name: "StepperSlice",
  initialState,
  reducers: {
    setActiveStep(state, action) {
      state.activeStep = action.payload;
    },
    setCoordinateSite(state, action) {
      state.coordinateSite = action.payload;
    },
  },
});

export const { setActiveStep, setCoordinateSite } = StepperROWStateSlice.actions;
export default StepperROWStateSlice.reducer;
